module.exports = __webpack_public_path__ + "img/mob_system.png";